import React from 'react';
import clsx from 'clsx';

/**
 * Atom: Spinner
 * Sizes: xs | sm | md | lg
 * color: 'brand' | 'white' | 'current'
 */
const sizeMap = {
  xs: 'h-3 w-3 border',
  sm: 'h-4 w-4 border-2',
  md: 'h-5 w-5 border-2',
  lg: 'h-8 w-8 border-[3px]',
};

const colorMap = {
  brand:   'border-brand-200 border-t-brand-600',
  white:   'border-white/30 border-t-white',
  current: 'border-current/20 border-t-current',
  slate:   'border-slate-200 border-t-slate-600',
};

const Spinner = ({ size = 'md', color = 'brand', className = '' }) => (
  <span
    role="status"
    aria-label="Chargement…"
    className={clsx(
      'animate-spin rounded-full flex-shrink-0',
      sizeMap[size] || sizeMap.md,
      colorMap[color] || colorMap.brand,
      className
    )}
  />
);

export default Spinner;
